import { AbstractModel, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Amenity } from './amenity';
import { VehicleType } from './vehicle-type';

@inheritSerialization(AbstractModel)
export class Vehicle extends AbstractModel {
  @autoserialize dotsVehicleIdentifier: number;

  @autoserialize driverId: number;

  @autoserialize make: string;

  @autoserialize model: string;

  @autoserialize year: number;

  @autoserialize licensePlate: string;

  @autoserialize color: string;

  @autoserialize active: boolean;

  @autoserializeAs(Amenity)
  amenities: Array<Amenity>;

  @autoserializeAs(VehicleType)
  vehicleType: VehicleType;

  get displayVehicle(): string {
    return this.year + ' ' + this.make + ' ' + this.model;
  }

  static OnSerialized(instance: Vehicle, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.licensePlate)) {
      json.licensePlate = instance.licensePlate.toUpperCase();
    }
  }
}
